import { AccountType } from '@/data/usecases/account/account-type'
import { Account } from '@/domain/usecases'
import { ReactNode, lazy } from 'react'

const OnboardingWelcomePage = lazy(
  () => import('@/presentation/pages/onboarding/onboarding-welcome-page')
)

const OnboardingLayout = lazy(() => import('@presentation/components/ui/layout/onboarding-layout'))

const OnboardingCheckDataPage = lazy(
  () => import('@/presentation/pages/onboarding/onboarding-check-data/onboarding-check-data-page')
)

const DependentOnboardingCheckDataPage = lazy(
  () =>
    import(
      '@/presentation/pages/onboarding/onboarding-check-data/dependent-onboarding-check-data-page'
    )
)
const Onboarding1Page = lazy(
  () => import('@/presentation/pages/onboarding/onboarding-1/onboarding-1-page')
)

const OnboardingPersonalDataPage = lazy(
  () => import('@/presentation/pages/onboarding/onboarding-personal-data-page')
)

const DependentOnboarding1Page = lazy(
  () => import('@/presentation/pages/onboarding/onboarding-1/dependent-onboarding-1-page')
)

const OnboardingCareerMomentPage = lazy(
  () =>
    import('@/presentation/pages/onboarding/onboarding-career-moment/onboarding-career-moment-page')
)

const OnboardingLearningObjectivesPage = lazy(
  () => import('@/presentation/pages/onboarding/onboarding-learning-objectives-page')
)

const OnboardingContentTypesPage = lazy(
  () =>
    import('@/presentation/pages/onboarding/onboarding-content-types/onboarding-content-types-page')
)

const OnboardingContentFormatsPage = lazy(
  () =>
    import(
      '@/presentation/pages/onboarding/onboarding-content-formats/onboarding-content-formats-page'
    )
)

const OnboardingProfessionalTrajectoryPage = lazy(
  () => import('@/presentation/pages/onboarding/onboarding-professional-trajectory-page')
)

const Onboarding2Page = lazy(() => import('@/presentation/pages/onboarding/onboarding-2-page'))
const Onboarding3Page = lazy(() => import('@/presentation/pages/onboarding/onboarding-3-page'))
const Onboarding4Page = lazy(() => import('@/presentation/pages/onboarding/onboarding-4-page'))
const OnboardingSecurityPage = lazy(
  () => import('@/presentation/pages/onboarding/onboarding-security-page')
)

const OnboardingCompletedPage = lazy(
  () => import('@/presentation/pages/onboarding/onboarding-completed-page')
)

export const makeOnboardingWelcomePage = (): ReactNode => {
  return <OnboardingWelcomePage />
}

export const makeOnboardingLayout = (): ReactNode => {
  return <OnboardingLayout />
}

export const makeOnboardingCheckDataPage = (accountProfile: Account.Model): ReactNode => {
  return AccountType.Enum.DEPENDENT.is(accountProfile) ? (
    <DependentOnboardingCheckDataPage />
  ) : (
    <OnboardingCheckDataPage />
  )
}

export const makeOnboarding1Page = (accountProfile: Account.Model): ReactNode => {
  return AccountType.Enum.DEPENDENT.is(accountProfile) ? (
    <DependentOnboarding1Page />
  ) : (
    <Onboarding1Page />
  )
}

export const makeOnboarding2Page = (): ReactNode => {
  return <Onboarding2Page />
}

export const makeOnboardingPersonalDataPage = (): ReactNode => {
  return <OnboardingPersonalDataPage />
}

export const makeOnboardingProfessionalTrajectoryPage = (): ReactNode => {
  return <OnboardingProfessionalTrajectoryPage />
}

export const makeOnboardingCareerMomentPage = (): ReactNode => {
  return <OnboardingCareerMomentPage />
}

export const makeOnboardingLearningObjectivesPage = (): ReactNode => {
  return <OnboardingLearningObjectivesPage />
}

export const makeOnboardingContentTypesPage = (): ReactNode => {
  return <OnboardingContentTypesPage />
}

export const makeOnboardingContentFormatsPage = (): ReactNode => {
  return <OnboardingContentFormatsPage />
}

export const makeOnboarding3Page = (): ReactNode => {
  return <Onboarding3Page />
}

export const makeOnboarding4Page = (): ReactNode => {
  return <Onboarding4Page />
}

export const makeOnboardingSecurityPage = (): ReactNode => {
  return <OnboardingSecurityPage />
}

export const makeOnboardingCompletedPage = (): ReactNode => {
  return <OnboardingCompletedPage />
}
